export const AVATAR_MENTION_COLOR_MAP = {
    'bg-slate-600': 'bg-slate-600/15 dark:bg-slate-400/20 text-slate-600 dark:text-slate-400',
    'bg-red-600': 'bg-red-600/15 dark:bg-red-400/20 text-red-600 dark:text-red-400',
    'bg-orange-600': 'bg-orange-600/15 dark:bg-orange-400/20 text-orange-600 dark:text-orange-400',
    'bg-amber-600': 'bg-amber-600/15 dark:bg-amber-400/20 text-amber-600 dark:text-amber-400',
    'bg-yellow-600': 'bg-yellow-600/15 dark:bg-yellow-400/20 text-yellow-600 dark:text-yellow-400',
    'bg-lime-600': 'bg-lime-600/15 dark:bg-lime-400/20 text-lime-600 dark:text-lime-400',
    'bg-green-600': 'bg-green-600/15 dark:bg-green-400/20 text-green-600 dark:text-green-400',
    'bg-emerald-600': 'bg-emerald-600/15 dark:bg-emerald-400/20 text-emerald-600 dark:text-emerald-400',
    'bg-teal-600': 'bg-teal-600/15 dark:bg-teal-400/20 text-teal-600 dark:text-teal-400',
    'bg-cyan-600': 'bg-cyan-600/15 dark:bg-cyan-400/20 text-cyan-600 dark:text-cyan-400',
    'bg-blue-600': 'bg-blue-600/15 dark:bg-blue-400/20 text-blue-600 dark:text-blue-400',
    'bg-indigo-600': 'bg-indigo-600/15 dark:bg-indigo-400/20 text-indigo-600 dark:text-indigo-400',
    'bg-violet-600': 'bg-violet-600/15 dark:bg-violet-400/20 text-violet-600 dark:text-violet-400',
    'bg-purple-600': 'bg-purple-600/15 dark:bg-purple-400/20 text-purple-600 dark:text-purple-400',
    'bg-fuchsia-600': 'bg-fuchsia-600/15 dark:bg-fuchsia-400/20 text-fuchsia-600 dark:text-fuchsia-400',
    'bg-pink-600': 'bg-pink-600/15 dark:bg-pink-400/20 text-pink-600 dark:text-pink-400',
    'bg-neutral-600': 'bg-neutral-600/15 dark:bg-neutral-400/20 text-neutral-600 dark:text-neutral-400' // Default fallback
};

export const LABEL_COLOR_MAP = {
    'gray': 'bg-gray-500',
    'red': 'bg-red-500',
    'yellow': 'bg-yellow-500',
    'green': 'bg-green-500',
    'blue': 'bg-blue-500',
    'purple': 'bg-purple-500',
    'violet': 'bg-violet-500',
    'pink': 'bg-pink-500',
    'emerald': 'bg-emerald-500',
    'cyan': 'bg-cyan-500'
};

export const STATUS_COLORS = {
    'gray': {
        text: 'text-gray-500',
        bg: 'bg-gray-500'
    },
    'red': {
        text: 'text-red-500',
        bg: 'bg-red-500'
    },
    'yellow': {
        text: 'text-yellow-500',
        bg: 'bg-yellow-500'
    },
    'green': {
        text: 'text-green-500',
        bg: 'bg-green-500'
    },
    'blue': {
        text: 'text-blue-500',
        bg: 'bg-blue-500'
    },
    'purple': {
        text: 'text-purple-500',
        bg: 'bg-purple-500'
    },
    'violet': {
        text: 'text-violet-500',
        bg: 'bg-violet-500'
    },
    'pink': {
        text: 'text-pink-500',
        bg: 'bg-pink-500'
    },
    'emerald': {
        text: 'text-emerald-500',
        bg: 'bg-emerald-500'
    },
    'cyan': {
        text: 'text-cyan-500',
        bg: 'bg-cyan-500'
    }
};
